import {translateConnectionObjectToArray} from 'nutshell-core';

import type {Tag} from 'shells/tags-editor/tags-editor';

import type {
    GetLeadTagMaps_lead_tagMaps_edges as LeadTagMapsEdge,
    GetLeadTagMaps_lead_tagMaps_edges as TagMapEdge,
} from 'nutshell-graphql-types';

import {combineFetchedOptionsWithCurrentOptions} from '../../../core/select/helpers';

export const useLeadTags = (
    leadTagMaps: LeadTagMapsEdge[],
    fetchTags: (arg1: string) => Promise<any>
) => {
    const leadTags = leadTagMaps ? getTagsFromTagMapEdges(leadTagMaps) : [];

    const handleFetchTags = (searchTerm: string, currentTags: Tag[]) =>
        fetchTags(searchTerm)
            .then(({data}) => (data ? translateConnectionObjectToArray(data.tags) : []))
            .then((fetchedTags: Tag[]) =>
                combineFetchedOptionsWithCurrentOptions(fetchedTags, currentTags)
            );

    return {
        leadTags,
        handleFetchTags,
    };
};

function getTagsFromTagMapEdges(tagMapEdges: TagMapEdge[]): Tag[] {
    // @ts-expect-error
    return tagMapEdges.map((edge) => ({
        ...edge.node,
        creator: edge.creator,
        createdTime: edge.createdTime,
    }));
}
